import { NumValBase } from "../../../Utils/NumberValue";
import { Stadium } from "../../Stadium/Stadium";
import { TargetBase } from "../Targets/Target";
import { TargetSettingsBase } from "../TargetSettings";
import { eTargetType } from "../TargetType";
import { TargetControllerBase } from "./BaseController";



export class StaticTargetSettings extends TargetSettingsBase {
    get x(): number | NumValBase { return this._x; }
    private _x: number | NumValBase;

    get y(): number | NumValBase { return this._y; }
    private _y: number | NumValBase;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(type: eTargetType, scale: number, x: number | NumValBase, y: number | NumValBase, flags?: number) {
        super(type, scale, flags);
        this._x = x
        this._y = y
    }
}



export class StaticTargetController extends TargetControllerBase {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(target: TargetBase, settings: StaticTargetSettings): void {
        super.init(target, settings);

        // Pozice
        this.convertRatioPos2WorldPos(NumValBase.getValue(settings.x), NumValBase.getValue(settings.y));

        this._target.container.setPosition(this._pos.x, this._pos.y, Stadium.END_Z + target.id * TargetBase.Z_SPACING);
    }
}